import Vue from "vue";
import Vuex from "vuex";
// 应用vuex插件
Vue.use(Vuex);

// 创建并暴露store
const store = new Vuex.Store({
  state: {
    tabIndex: 0,
    language: localStorage.getItem("lang") || "CN",
    newsDetailContent: {},
  },
  //准备getters——用于将state中的数据进行加工
  getters: {},
  //准备mutations——用于操作数据（state）
  mutations: {
    setTabIndex(state: any, payload: Number) {
      state.tabIndex = payload;
    },
    setLanguage(state: any, payload: "CN" | "EN") {
      state.language = payload;
      localStorage.setItem("lang", payload);
    },
    setNewsDetailContent(state: any, payload: Record<string, any>) {
      state.newsDetailContent = { ...payload };
    },
  },
  //准备actions——用于响应组件中的动作
  actions: {},
  modules: {},
});
export default store;
